<template>
  <basic-portlet :title="title">
    <form class="kt-form" role="form"
          method="post"
          @submit.prevent="saveRelease">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="release_name">Release Name</label>
            <input id="release_name" v-model="name"
                   type="text"
                   class="form-control">
            <span class="form-text text-muted">Date will be appended to name i.e 'Major Release - 01/01/2021'</span>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="release_date">Release Date</label>
            <datetime id="release_date"
                      v-model="release_date"
                      name="Release Date" input-class="form-control kt-input"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss" />
          </div>

          <div class="form-group">
            <div class="d-flex flex-column">
              <ss-checkbox id="published" v-model="published">
                Published
              </ss-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <hr>
        </div>
      </div>

      <div class="row content-fields">
        <!-- Release Features -->
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label>Features</label>
            <div v-for="(feature, feature_index) in content.features" :key="feature_index">
              <div class="feature-container">
                <textarea v-model="feature.description" class="w-90 form-control"
                          placeholder="e.g. Added ability to ..." />
                <div class="buttons">
                  <a v-if="content.features.length === feature_index + 1"
                     class="btn btn-ss btn-icon btn-sm" @click="addContentType('features')"><i class="la la-plus" /></a>
                  <a v-if="feature_index" class="btn btn-ss-danger btn-icon btn-sm"
                     @click="removeContentType('features', feature_index)"><i class="la la-minus" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Release Enhancements -->
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label>Enhancements</label>
            <div v-for="(enhancement, enhancement_index) in content.enhancements" :key="enhancement_index">
              <div class="feature-container">
                <textarea v-model="enhancement.description" class="w-90 form-control"
                          placeholder="e.g. Improved speed of ..." />
                <div class="buttons">
                  <a v-if="content.enhancements.length === enhancement_index + 1"
                     class="btn btn-ss btn-icon btn-sm" @click="addContentType('enhancements')"><i class="la la-plus" /></a>
                  <a v-if="enhancement_index" class="btn btn-ss-danger btn-icon btn-sm"
                     @click="removeContentType('enhancements', enhancement_index)"><i class="la la-minus" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Release Bug Fixes -->
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label>Bug Fixes</label>
            <div v-for="(bug_fix, bug_fix_index) in content.bug_fixes" :key="bug_fix_index">
              <div class="feature-container">
                <textarea v-model="bug_fix.description" class="w-90 form-control"
                          placeholder="e.g. Resolved issue preventing ..." />
                <div class="buttons">
                  <a v-if="content.bug_fixes.length === bug_fix_index + 1"
                     class="btn btn-ss btn-icon btn-sm" @click="addContentType('bug_fixes')"><i class="la la-plus" /></a>
                  <a v-if="bug_fix_index" class="btn btn-ss-danger btn-icon btn-sm"
                     @click="removeContentType('bug_fixes', bug_fix_index)"><i class="la la-minus" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <hr>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <button class="btn btn-ss-standout" type="submit">
            Save
          </button>
        </div>
      </div>
    </form>
  </basic-portlet>
</template>

<script>
import BasicPortlet from "VueComponents/BasicPortlet";
import {
  mysqlDateTimeUTCToLocal,
} from 'Helpers/formatters';

export default {
  components: {
    BasicPortlet,
  },
  data() {
    return {
      release: window.release,
      name: null,
      content: {},
      additional_notes: null,
      release_date: null,
      published: false,
    };
  },
  computed: {
    title() {
      if (!this.release) {
        return 'Create Release';
      } else {
        return `Edit Release : ${this.release.name}`;
      }
    },
  },
  mounted() {
    this.setupRelease();
    this.setupContent();
  },
  methods: {
    setupRelease() {
      if (this.release) {
        this.name = this.release.name;
        this.content = this.release.content;
        this.additional_notes = this.release.additional_notes;
        this.release_date = moment(mysqlDateTimeUTCToLocal(this.release.release_date)).toISOString();
        this.published = this.release.published;
      } else {
        // Release Date to today's date with moment
        this.release_date = moment().format('YYYY-MM-DD H:M');
        this.name = 'Release';
      }
    },
    setupContent() {
      // Always add one blank entry for each content type
      const vm = this;
      const content_types = ['features', 'bug_fixes', 'enhancements'];
      _.forEach(content_types, (content_type) => {
        if (!vm.content[content_type] || !vm.content[content_type].length) {
          vm.content[content_type] = [];
          vm.content[content_type].push({ description: null });
        }
      });

      // Create a non-reactive copy of content to force vue to recognise changes
      this.content = JSON.parse(JSON.stringify(this.content));
    },
    addContentType(content_type) {
      this.content[content_type].push({
        description: null,
      });
    },
    removeContentType(content_type, content_index) {
      this.content[content_type] = _.remove(this.content[content_type], (feature, index) => index !== content_index);
    },
    saveRelease() {
      // Strip out empty entries
      const content = {};
      _.forEach(this.content, (entries, content_type) => {
        if (entries.length && entries[0].description !== null && entries[0].description !== '') {
          content[content_type] = entries;
        }
      });

      // Build the post data
      const post_data = {
        name: this.name,
        content: content,
        release_date: this.release_date,
        published: this.published,
        additional_notes: this.additional_notes,
      };

      if (this.release && this.release.id) {
        this.updateRelease(post_data);
      } else {
        this.createRelease(post_data);
      }
    },
    createRelease(post_data) {
      axios.post('/api/v1/admin/releases', post_data).then((response) => {
        toastr.success("Release Created. Redirecting...");
        window.location.href = `/admin/releases/${response.data.data.id}/edit`;
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
    updateRelease(post_data) {
      axios.put(`/api/v1/admin/releases/${this.release.id}`, post_data).then((response) => {
        this.release = response.data.data;
        this.setupContent();
        toastr.success("Release Updated");
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
  },

};
</script>

<style lang="scss" scoped>
  .content-fields {
    label {
      font-weight:bold;
      margin-bottom:1.5rem;
    }
  }

  .feature-container {
    position:relative;
    textarea {
      width:80%;
      float:left;
      margin-bottom:1rem;
    }
    .buttons {
      margin-left:5%;
      width:15%;
      float:left;
    }
  }
</style>
